"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sendingReferralDataError = exports.sendingReferralData = exports.maxReferrals = exports.someReferrals = exports.noReferrals = exports.initialized = void 0;
exports.initialized = 'INITIALIZED';
exports.noReferrals = 'NO_REFERRALS';
exports.someReferrals = 'SOME_REFERRALS';
exports.maxReferrals = 'MAX_REFERRALS';
exports.sendingReferralData = 'SENDING_REFERRAL_DATA';
exports.sendingReferralDataError = 'SENDING_REFERRAL_DATA_ERROR';
//# sourceMappingURL=states.js.map